var map = {
	"./account/annual_fee_excellent.png": "f7a5",
	"./account/annual_fee_standard.png": "bc29",
	"./account/bg.png": "6a00",
	"./account/clock.png": "e5c2",
	"./account/expire.png": "4d96",
	"./account/head_daoqi.png": "0e5b",
	"./account/head_type_1.png": "d2e2",
	"./account/head_type_2.png": "96ec",
	"./account/head_type_3.png": "d047",
	"./account/head_type_4.png": "16a4",
	"./account/icon_package.png": "60b7",
	"./account/icon_question_mark.png": "8292",
	"./account/r.png": "d3976",
	"./account/type_1.png": "13d3",
	"./account/type_2.png": "e288",
	"./account/type_3.png": "e871",
	"./account/type_4.png": "26a3",
	"./accountBg.png": "8150",
	"./activity/double-charge-overlay.png": "425e",
	"./activity/first-charge-double.png": "2898",
	"./activity/menu-extra.png": "a4d5",
	"./activity/pay-extra.png": "d3b4",
	"./activity/play-icon.png": "0611",
	"./agreement_cover.png": "144a",
	"./alipay.png": "65e5",
	"./arrow_right_icon.png": "0d03",
	"./banner/header_bg.png": "5294",
	"./banner/header_logo.png": "6df6",
	"./btn_next_green_pre.png": "fe13",
	"./btn_next_green_xuanfu.png": "ac91",
	"./circle-bg.png": "5c36",
	"./code-bg.png": "b409",
	"./contact_clerk.png": "dc18",
	"./contact_phar.png": "c861",
	"./custom.png": "87e1",
	"./custom2.png": "1963",
	"./disabledTag.png": "d1fc",
	"./down_icon.png": "8b23",
	"./drug_example_pic.png": "ede7",
	"./icon_360.png": "73e89",
	"./icon_account.png": "bd06",
	"./icon_agree.png": "2912",
	"./icon_agree_01.png": "dafd",
	"./icon_apply.png": "9d59",
	"./icon_average.png": "db27",
	"./icon_b2b.png": "4ebf",
	"./icon_chat.png": "52df",
	"./icon_chrome.png": "21d4",
	"./icon_close.png": "6cef",
	"./icon_dashboard.png": "de17",
	"./icon_default_doctor_avatar.png": "bca6",
	"./icon_delete.png": "9976",
	"./icon_doctor.png": "337a",
	"./icon_download.png": "9e8b",
	"./icon_drug.png": "d54a",
	"./icon_drug_category.png": "021e",
	"./icon_drug_management.png": "9f55",
	"./icon_edit.png": "58fd",
	"./icon_edit_01.png": "65de",
	"./icon_equipment.png": "1c46",
	"./icon_info.png": "ed72",
	"./icon_info_circle.png": "6e18",
	"./icon_leave.png": "7584",
	"./icon_list.png": "3a50",
	"./icon_news.png": "644d",
	"./icon_photo.png": "3a32",
	"./icon_pic.png": "b774",
	"./icon_punch.png": "743a",
	"./icon_quit_nor.png": "9662",
	"./icon_quit_pre.png": "5699",
	"./icon_registration_record.png": "2669",
	"./icon_right.png": "13c0",
	"./icon_select.png": "8a75",
	"./icon_service_package.png": "a19b",
	"./icon_shop.png": "2ee1",
	"./icon_spec_cate.png": "7ec5",
	"./icon_staff.png": "6f09",
	"./icon_success.png": "14b8",
	"./icon_total.png": "2a56",
	"./icon_unselect.png": "6ae1",
	"./icon_upload.png": "e736",
	"./icon_wait.png": "169a",
	"./icon_wechat.png": "2cb3",
	"./img.png": "ba75",
	"./left_arrow.png": "0bfa",
	"./logo-white.png": "39cc",
	"./logo.png": "4ffd",
	"./modal_close.png": "1624",
	"./new/banner702x176.png": "97a9",
	"./new/header_bg.png": "f5de",
	"./new/login_logo.png": "c0bc",
	"./new/ydyj_bg.png": "99fd",
	"./newlogo.png": "0ddd",
	"./no_data.png": "32a2",
	"./photo_consult_bg.png": "0bc8",
	"./photo_consult_icon.png": "0981",
	"./pre_eg_1.png": "00a6",
	"./pre_eg_2.png": "687d",
	"./prints/1*1.png": "ffeb",
	"./prints/1*2.png": "47af",
	"./prints/2*2.png": "2dfd4",
	"./qrcode.png": "a596",
	"./qrcode2.png": "1e4b",
	"./question_mark.png": "d858",
	"./renewal_notice.png": "a0cb",
	"./shopmanager/example-new.png": "4799",
	"./shopmanager/example-old.png": "7b0a",
	"./shopmanager/sample-chinese-new.png": "dc03",
	"./shopmanager/sample-chinese-old.png": "73e1",
	"./shopmanager/sample-west-new.png": "80dc",
	"./shopmanager/sample-west-old.png": "3afb",
	"./shrink_video_icon.png": "ca07",
	"./sign.png": "de03",
	"./simple_consult_bg.png": "007a",
	"./simple_consult_icon.png": "016f",
	"./tip.png": "a736",
	"./to_picture_icon.png": "2310",
	"./user_header.png": "d33f",
	"./video_answer.png": "0992",
	"./video_consult_bg--new.png": "1143",
	"./video_consult_bg.png": "8cef",
	"./video_consult_icon.png": "2d7d",
	"./video_expand.png": "4099",
	"./video_icon.png": "1d89",
	"./video_reject.png": "4776",
	"./video_shrink.png": "7dbd",
	"./wepay.png": "3931",
	"./wzlogo.png": "1191",
	"./zhiyun_tip.png": "7a53"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b967";